import { Member } from "src/patents/patents";
import { IpRight } from "../interfaces/renewal_types";
import { IpRightImportStatusInfo, ValidationMessage, importStatusExtraction as genericImportStatusExtraction } from "../state/modern_states";
import { PRIpRight } from "./patent_renewals";

export function importStatusExtraction(
    {member, ipRight, prIpRight, validationErrors}:
    {member: Member, ipRight?: IpRight, prIpRight?: PRIpRight, validationErrors?: ValidationMessage[]}
): IpRightImportStatusInfo {
  const status = genericImportStatusExtraction({member, ipRight, validationErrors})

  //if (status.status === 'not-handled' && status.substatus === 'can-import') {
  //  // PR requires grant number
  //  if (member.patentNumber === undefined) {
  //    return {status: 'not-handled', substatus: 'missing-data',  messages: ['patentNumber']}
  //  }
  //}
  return {...status, 
    inReview: prIpRight?.is_pending_instruction_change_review,
    inSurcharge: prIpRight?.should_be_renewed_in_surcharge,
  }
}